import React, {useEffect, useState} from "react";
import {NavLink, useLocation, useNavigate} from "react-router-dom";

export const NavBar = ({profile}) => {
  const location = useLocation()
  const navigate = useNavigate()
  const [showDrop, setShowDrop] = useState(false)

  useEffect(() => {
    return window.addEventListener('click', (e) => {
      if (e.target.closest('.navigate__profile') === null) {
        setShowDrop(false)
      }
    })
  }, [location])

  const logout = () => {
    localStorage.removeItem('userToken')
    navigate('/login')
  }
  return (
     <>
       <div className="navigate">
         <div className="container navigate__container">
           <div onClick={() => {setShowDrop(!showDrop)}} className="navigate__profile">
             <div className="navigate__profile-photo">{profile?.name.slice(0,1)}</div>
             <p className="navigate__profile-name">{profile?.name}</p>
             <span className="arrow">
              <svg viewBox="0 0 8 13" width="8" height="8" >
              <path d="M6.6 0L7.7 1.07519L2.11556 6.45113L7.7 11.9248L6.6 13L0 6.54887V6.45113L1.1 5.47368L6.6 0Z"></path>
            </svg>
            </span>
             {showDrop && <div className="navigate__dropdown">
               <div onClick={logout} className="navigate__dropdown-item">Log out</div>
             </div>}
           </div>
         </div>
       </div>
       <div className="navbar">
         <div className="navbar__title"><img src="/assets/icons/Logo.svg" alt=""/></div>
         <div className="navbar__links">
           <div className="navbar__link">
             <NavLink
               to="users"
               className={({isActive}) =>
                 isActive ? 'activeLink' : 'unActiveLink'
               }
             >
               <span><img src="/assets/icons/users.svg" alt=""/></span>Users
             </NavLink>
           </div>
           <div className="navbar__link">
             <NavLink
               to="default-avatars"
               className={({isActive}) =>
                 isActive ? 'activeLink' : 'unActiveLink'
               }
             >
               <span><img src="/assets/icons/avatars.svg" alt=""/></span>Default Avatars
             </NavLink>
           </div>
           <div className="navbar__link">
             <NavLink
               to="words"
               className={({isActive}) =>
                 isActive ? 'activeLink' : 'unActiveLink'
               }
             >
               <span><img src="/assets/icons/words.svg" alt=""/></span>Words
             </NavLink>
           </div>
           {/*<div className="navbar__link">*/}
           {/*  <NavLink*/}
           {/*    to="settings"*/}
           {/*    className={({isActive}) =>*/}
           {/*      isActive ? 'activeLink' : 'unActiveLink'*/}
           {/*    }*/}
           {/*  >*/}
           {/*    <span><img src="/assets/icons/settings.svg" alt=""/></span>Settings*/}
           {/*  </NavLink>*/}
           {/*</div>*/}
         </div>
       </div>
     </>
  )
}
